import { css } from '@emotion/react';
import { ArrowSquareOut } from '@phosphor-icons/react';
import { useDeploymentClientState } from 'client/state/DeploymentClientState';
import { useDeploymentStatusTree } from 'client/state/useDeploymentStatusTree';
import { useDeploymentWarning } from 'client/pages/deployment/useDeploymentWarning';
import { Button } from 'client/components/Button';
import type { DropdownMenuItemProps } from 'client/components/DropdownMenu';
import { DevelopButtonBlocker } from './DevelopButtonBlocker';

interface DevelopButtonProps {
  item: DropdownMenuItemProps & { 'data-name'?: string };
}

export const DevelopButton = ({ item }: DevelopButtonProps) => {
  const deploymentID = useDeploymentClientState((state) => state.document?.id);
  const statusTree = useDeploymentStatusTree(deploymentID);

  const containers = (statusTree?.containers.items || []).filter((item) => item.namespace === 'diploi');
  const { loadingToReadyState } = useDeploymentWarning({ containers });

  return (
    <DevelopButtonBlocker
      target={item.id}
      startingWarning={`This deployment is still starting up. ${item['data-name'] || 'Editor'} is not ready yet, please wait.`}
      stoppedWarning={`This deployment is stopped. ${item['data-name'] || 'Editor'} cannot be opened. Please start the deployment first.`}
    >
      <Button
        primary
        href={item.href}
        external
        target="_self"
        icon={<ArrowSquareOut />}
        pulsing={loadingToReadyState === 'loading'}
        highlight={loadingToReadyState === 'ready'}
        onClick={item.onClick as () => void}
        css={buttonStyle}
      >
        {item.icon}
        {item.title}
      </Button>
    </DevelopButtonBlocker>
  );
};

const buttonStyle = css`
  > span:not(.icon) {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 12px;
  }
`;
